import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CommonModule} from "@angular/common";
import { MotifModule } from "@ey-xd/motif-wc-angular"; 
import {IconoirMoreVert, IconoirNavArrowLeft, IconoirNavArrowRight, IconoirXmark} from "@ey-xd/motif-icon";

import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import { FeedbackService } from "app/core/service/feedback/feedback.service";
import { HttpErrorResponse } from "@angular/common/http";
import saveAs from "file-saver";
@Component({
  selector: 'survey-export-modal',
  templateUrl: './survey-export-modal.component.html',
  styleUrls: ['./survey-export-modal.component.scss'],
  imports: [CommonModule,
    MotifModule,
    ReactiveFormsModule, FormsModule,
  ],
  standalone: true
})
export class ModalExportSurverys {
  IconoirXmark = IconoirXmark;
  IconoirMoreVert = IconoirMoreVert;
  IconoirNavArrowLeft = IconoirNavArrowLeft;
  IconoirNavArrowRight = IconoirNavArrowRight;
  selectedAgent?: string;
  dateSingleFormControl = new FormControl();
  selectAgentFormControl = new FormControl();
  initialDate?: string;
  finalDate?: string;
  meRole: string = "0"

  @Input() open: boolean = false;
  @Output() modalClosed = new EventEmitter<void>();

  constructor(private feedbackService: FeedbackService) {}

  onModalClose() {
    this.modalClosed.emit();
  }

  onDateSelect(event: any) {
    try {
      const value = event?.detail || event;
      if (typeof value === 'string' && value) {
        const parsed = JSON.parse(value);
        this.initialDate = parsed.startDate || '';
        this.finalDate = parsed.endDate || '';
      }
    } catch {
      this.initialDate = '';
      this.finalDate = '';
    }
  }

  onSurveyExport() {
    if(!this.initialDate || !this.finalDate) {
      this.initialDate = '';
      this.finalDate = '';
    }
    
    if(this.selectAgentFormControl.value) {
      this.selectedAgent = this.selectAgentFormControl.value;
    } else {
      this.selectedAgent = "tbe"
    }
    this.feedbackService
      .exportSurvey(this.selectedAgent!, this.initialDate!, this.finalDate!)
      .subscribe({
        next: (data: Blob) => {
            console.log("entra1");
            const nameFromApi: string = 'CiT Feedback Report.xlsx';
            saveAs(data, nameFromApi);
        },
        error: (error: HttpErrorResponse) => {
            console.log(error);
        },
      });
  }
}





